export const constants = {
  UPDATE: 'UPDATE',
  RESET: 'RESET',
};
